@if(store.isError()) {
  <debtor-panel-error
    (reloadRequested)="handleReload()"
  />
} @else {
  <debtor-panel-loading-spinner [isLoading]="store.isLoading()" />
  <div class="payment-container">
    <div class="logo-container">
      <img src="../../../../assets/img/Logo.png" class="logo" alt="Asseta logo">
    </div>
    <div class="payment-card-container">
      <mat-card class="payment-card">
        <div class="banner">
          <img src="../../../../assets/img/autoPayBanner.png" alt="{{ 'alt-for-img.autoPay-banner' | translate }}">
        </div>
        <div class="payment-content">
          <h1 class="payment-title"> {{ 'payment.title' | translate }}</h1>
          <p class="payment-subtitle">{{ 'payment.sub-title' | translate }}</p>
          <mat-form-field appearance="outline" class="amount-input">
            <mat-label>{{ 'payment.input-label' | translate }} </mat-label>
            <input matInput appTwoDigitDecimalPrice
                  [ngModel]="this.store.amountToPayAsString()"
                  (ngModelChange)="checkValidation($event)"
                  type="textbox"
                  placeholder="{{ 'payment.input-label' | translate }}"
                  aria-required="true" required/> <div matTextSuffix>zł</div>
          </mat-form-field>
          @if (validationError()){
            <div class="validation-error">
              {{ 'payment.validation-error' | translate : { minAmount: this.store.minAmountForPayment() | number: '1.2-2' : 'fr-FR', maxAmount: this.store.maxAmountForPayment() | number: '1.2-2' : 'fr-FR'  } }}
            </div>
          }
          <button mat-raised-button  class="btn-common pay-button" (click)="goToPayment()"  >
            {{ 'payment.payment-btn' | translate }}
          </button>
             <button mat-flat-button  class="btn-border cancel-button" (click)="cancel()"  >
            {{ 'payment.payment-btn-back' | translate }}
          </button>
        </div>
      </mat-card>
    </div>
    <div class="footer-container">
      <debtor-panel-footer
      [transparent]="true"
      (navigateToOrderContact)="navigateToOrderContact()"
      />
    </div>
  </div>
}